module.exports = __webpack_public_path__ + "img/pr-7.be802aff.png";